import { Box, TextField, Typography } from '@mui/material';


const TransportPoint = ({ value = {}, onChange, label }) => {
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography variant="subtitle2">{label}</Typography>

      <TextField
        fullWidth
        variant="filled"
        label="Name"
        value={value.name || ''}
        onChange={(e) =>
          onChange({ ...value, name: e.target.value })
        }
      />

      <TextField
        fullWidth
        variant="filled"
        type="number"
        label="Latitude"
        value={value.latitude ?? ''}
        onChange={(e) =>
          onChange({ ...value, latitude: e.target.value })
        }
      />

      <TextField
        fullWidth
        variant="filled"
        type="number"
        label="Longitude"
        value={value.longitude ?? ''}
        onChange={(e) =>
          onChange({ ...value, longitude: e.target.value })
        }
      />
    </Box>
  );
};

export default TransportPoint;
